export const isTablet = () => {
   //console.log(document.documentElement.clientWidth);
    if (document.documentElement.clientWidth <= 1025) {
        return true;
    } else {
        return false;
    }
}